<template>
    <div class="pt-32">
       <div class="welcome-text text-center mb-10 text-5xl font-bold text-primary">お問い合わせ管理へようこそ</div>
       <div class="flex justify-center">
        <img src="logo.png" alt="">
       </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
.welcome-text{
    letter-spacing: 2px;
}
</style>